<template>
  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>
</template>

<script>
import * as mns from "@/store/mutation-types";

export default {
  anotherNameLife: "SimpleTextarea",
  computed: {
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>

</style>